// extracted by mini-css-extract-plugin
module.exports = {"name":"NameOfTile_name__jWaCP"};